import React, { useState } from "react";
import {
  Modal,
  Box,
  TextField,
  Button,
  Typography,
  Stack,
} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { authPut } from "../../../util/request/authPut";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const CancelBooking = (props) => {
  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [price, setPrice] = useState(
    props.eventData.package.non_refundable_deposite
  );
  const [selectedStatus, setSelectedStatus] = useState();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSubmit = async () => {
    if (!selectedDate || !selectedStatus) return;

    const result = await authPut({
      subLink: "booking",
      id: props.eventData._id,
      data: {
        ...props.eventData,
        non_refund_deposite:
          selectedStatus === "cancelled(non-refundable deposit)"
            ? props.eventData.non_refund_deposite
            : 0,
        non_refund_deposite_date: selectedDate?.format("YYYY-MM-DD"),
        booking_status: selectedStatus,
      },
    });
    if (result.status === "success") {
      props.reFreshData();

      setOpen(false);
    }

    handleClose();
  };

  return (
    <div>
      <Button
        variant="contained"
        onClick={handleOpen}
        sx={{ maxWidth: "100px" }}
        color="error"
      >
        Cancel
      </Button>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Stack>
            <Typography variant="h6" component="h2" gutterBottom>
              Please confirm to cancel the booking:{" "}
              {props.eventData.bookingDetail.celebrant}
            </Typography>{" "}
            <Typography variant="h6" component="h2" gutterBottom></Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                required
                label="Select Date"
                value={selectedDate}
                onChange={(newDate) => setSelectedDate(newDate)}
                renderInput={(params) => (
                  <TextField fullWidth {...params} sx={{ mb: 2 }} />
                )}
              />
            </LocalizationProvider>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
              <InputLabel id="demo-simple-select-standard-label">
                Deposite Detail
              </InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={selectedStatus}
                onChange={(e) => {
                  setSelectedStatus(e.target.value);
                }}
                label="Age"
              >
                {props.eventData.booking_status === "pending" && (
                  <MenuItem value={"cancelled(no deposit)"}>
                    {"Cancelled(no deposit)"}
                  </MenuItem>
                )}
                {props.eventData.booking_status === "booked" && (
                  <MenuItem value={"cancelled(refunded deposit)"}>
                    {"Cancelled(refunded deposit)"}
                  </MenuItem>
                )}
                {props.eventData.booking_status === "booked" && (
                  <MenuItem value={"cancelled(non-refundable deposit)"}>
                    {"Cancelled(non-refundable deposit)"}
                  </MenuItem>
                )}
              </Select>
            </FormControl>
          </Stack>
          <Stack direction="row" justifyContent="flex-end">
            <Button
              variant="outlined"
              fullWidth
              onClick={handleClose}
              sx={{ maxWidth: "100px", mr: "50px" }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              fullWidth
              onClick={handleSubmit}
              sx={{ maxWidth: "100px" }}
            >
              Submit
            </Button>
          </Stack>
        </Box>
      </Modal>
    </div>
  );
};

export default CancelBooking;
